import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'app-closer-sync-congrats-connected',
	templateUrl: './closer-sync-congrats-connected.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class CloserSyncCongratsConnectedComponent {}
